import { cva } from 'class-variance-authority';

export const triggerVariants = cva(
  [
    'relative box-border inline-flex w-full cursor-pointer items-center rounded-[5px] border border-transparent bg-[var(--select-field-bg,var(--color-form-field-bg,var(--color-surface-muted)))] px-4 text-left text-xs font-medium leading-3 text-[var(--color-form-field-text,var(--color-text-muted))]',
    'hover:shadow-[0_0_0_1px_var(--color-form-field-focus-ring,var(--color-nav-active-bg))] hover:outline-none',
    'focus:shadow-[0_0_0_1px_var(--color-form-field-focus-ring,var(--color-nav-active-bg))] focus:outline-none',
    'focus-visible:shadow-[0_0_0_2px_var(--color-form-field-focus-visible-ring)]',
    '[&[data-open=true][data-placement=bottom]]:rounded-b-none [&[data-open=true][data-placement=bottom]]:border-[var(--color-nav-active-bg)] [&[data-open=true][data-placement=bottom]]:border-b-border [&[data-open=true][data-placement=bottom]]:shadow-none [&[data-open=true][data-placement=bottom]]:outline-none',
    '[&[data-open=true][data-placement=top]]:rounded-t-none [&[data-open=true][data-placement=top]]:border-[var(--color-nav-active-bg)] [&[data-open=true][data-placement=top]]:border-t-border [&[data-open=true][data-placement=top]]:shadow-none [&[data-open=true][data-placement=top]]:outline-none',
  ],
  {
    variants: {
      size: {
        sm: 'h-8',
        md: 'h-10',
      },
      state: {
        default: '',
        error: [
          '!border-transparent !shadow-[0_0_0_1px_var(--color-form-field-error)] !outline-none focus-visible:!shadow-[0_0_0_2px_var(--color-form-field-error)]',
          '[&[data-open=true][data-placement=bottom]]:!border-[var(--color-form-field-error)] [&[data-open=true][data-placement=bottom]]:!border-b-border [&[data-open=true][data-placement=bottom]]:!shadow-none',
          '[&[data-open=true][data-placement=top]]:!border-[var(--color-form-field-error)] [&[data-open=true][data-placement=top]]:!border-t-border [&[data-open=true][data-placement=top]]:!shadow-none',
        ].join(' '),
        disabled:
          'pointer-events-none cursor-default !border-transparent !bg-[var(--color-form-field-disabled-bg,var(--color-surface-muted))] !text-[var(--color-form-field-disabled-text,var(--color-text-muted))] !shadow-none !outline-none',
      },
    },
    defaultVariants: {
      size: 'md',
      state: 'default',
    },
  },
);

export const panelClassName = 'max-h-[200px]';

export const searchInputClassName = [
  "h-5 w-full cursor-text border-none bg-transparent p-0 font-['General_Sans',sans-serif] text-xs font-medium leading-3 outline-none",
  '!text-[var(--color-form-field-text,var(--color-text-muted))]',
  'placeholder:text-[var(--color-form-field-placeholder,var(--color-text-muted))] placeholder:opacity-100 placeholder:font-medium',
].join(' ');

export const optionClassName = [
  'option block cursor-pointer px-[15px] py-2.5',
  'hover:bg-[var(--color-form-field-hover-overlay,rgba(0,0,0,0.06))]',
].join(' ');

export const optionCheckVariants = cva(
  'mr-2 inline-flex h-3.5 w-3.5 shrink-0 items-center justify-center rounded-[3px] border align-middle text-[10px] leading-none',
  {
    variants: {
      checked: {
        true: 'border-[var(--color-nav-active-bg)] bg-[var(--color-nav-active-bg)] text-[var(--color-title)]',
        false: 'border-[var(--color-form-field-placeholder,var(--color-text-muted))] bg-transparent',
      },
    },
    defaultVariants: {
      checked: false,
    },
  },
);
